import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["question", "mode", "propsRegistry"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { QUESTION_COMPONENTS_REGISTRY } from '../registries';
import { QuestionContextProvider } from './question.context';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionManager = function QuestionManager(_ref) {
  var question = _ref.question,
      mode = _ref.mode,
      propsRegistry = _ref.propsRegistry,
      rest = _objectWithoutProperties(_ref, _excluded);

  var registeredComponents = QUESTION_COMPONENTS_REGISTRY[question.type];

  if (!registeredComponents) {
    console.error("Question type ".concat(question.type, " is not supported"));
    return null;
  }

  var ActiveComponent = registeredComponents[mode]; // If component with mode is inactive or not support -> not render

  if (!ActiveComponent) {
    console.error("Question type ".concat(question.type, " with mode ").concat(mode, " is not supported"));
    return null;
  }

  return /*#__PURE__*/_jsx(QuestionContextProvider, {
    question: question,
    children: /*#__PURE__*/_jsx(ActiveComponent, _objectSpread({
      states: propsRegistry.states,
      actions: propsRegistry.actions
    }, rest))
  });
};